<template>
  <div>
  <section>
    <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
    <div class="hero">
      <div class="hero-body" ref="myhero">
        <div class="container box has-background-white-bis" ref="credite">
          <div class="columns is-multiline">
            <div class="column is-12">
            </div>
            <div class="column is-12">
              <form class="has-text-centered steps-content is-full" ref="formContainer" style="width: 100% !important;">
                <section class="has-text-left" id="contentContainer" ref='cropper'>
                  <div class="columns is-multiline" ref="columnContainer">
                    <div class="column is-12 box">
                    <div class="columns is-centered is-vcentered">
                      <div class="column is-6" v-if="hasSalesVideo">
                        <div class="field">
                          <div class="video-wrapper" style="display: flex; justify-content: center; align-items: center;"> <!-- Added flex styles here -->
                            <video style="height: 500px;" class="video_player" controls crossorigin>
                              <source :src="videoUrl" type="video/mp4" />
                            </video>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="notification has-background-danger has-text-white">
                    Vehicle information
                  </div>
                  <div class="column is-12 box">
                      <div class="field">
                        <label class="label">Vehicle</label>
                        <span class="is-inline-block" v-html="makeOverview(inventoryItem)"></span>
                      </div>
                   </div>
                   <div class="notification has-background-danger has-text-white">
                    Photos taken for you
                  </div>
                  <section v-if="hasIncludedAttachments">
                    <div>
                  <figure class="image-grid" @click="onViewSalesVideoImages" title="Click to view images">
                    <div class="image-item" v-for="(attachment) in includedAttachments" :key="attachment.id">
                      <img :src="attachment.fileLocation" :alt="attachment.description" class="grid-image" />
                    </div>
                    <span ref="salesVideosImageViewer" v-viewer.static="{inline: false, title: true}">
                      <img
                        v-for="(attachment) in includedAttachments"
                        :key="attachment.id"
                        :src="attachment.fileLocation"
                        :alt="attachment.description"
                        style="display:none" />
                      </span>
                      </figure>
                    </div>
                  </section>
                  <section v-if="hasInventoryPhotoFiles">
                  <div class="column is-12 box">
                    <div class="is-inline-flex iPhoto">
                      <div>
                        <div class="field">
                          <label class="label">Photos</label>
                          <figure class="image-grid" @click="onViewInventoryImages" title="Click to view images">
                            <div class="image-item" v-for="(attachment) in inventoryPhotoFiles" :key="attachment.id">
                              <img :src="attachment.fileLocation" :alt="attachment.description" class="grid-image" />
                            </div>
                            <span ref="inventoryImageViewer" v-viewer.static="{inline: false, title: true}">
                              <img
                                v-for="(attachment) in inventoryPhotoFiles"
                                :key="attachment.id"
                                :src="attachment.fileLocation"
                                :alt="attachment.description"
                                style="display:none" />
                            </span>
                          </figure>
                        </div>
                      </div>
                    </div>
                  </div>
                  </section>
                </section>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import customerMixin from '@/mixins/customer/index'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import utilitiesMixin from '@/mixins/generic/utilities'
import { mapActions } from 'vuex'

export default {
  name: 'InventoryInformation',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    inventoryItem: {
      type: Object,
      default: null
    },
    supplier: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    inventorySalesVideoId: {
      type: Number,
      default: 0
    },
    attachmentMediaIds: {
      type: String,
      default: ''
    }
  },
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  mixins: [validateBeforeSubmitMixin, customerMixin, utilitiesMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: true,
      currentStep: 0,
      serverErrors: [],
      serverErrorMessage: '',
      preventClick: false,
      currentUrl: '',
      inventoryPhotoFiles: [],
      showFileNameColumn: window.innerWidth > 500,
      windowContainerWidth: window.innerWidth
    }
  },
  computed: {
    currentScope: function () {
      return this.availableScopes[this.currentStep]
    },
    inventoryItemsSalesVideos: function () {
      if (this.inventoryItem && this.inventoryItem.salesVideos) {
        return this.inventoryItem.salesVideos
      }
      return []
    },
    referencedSalesVideo: function () {
      if (this.inventorySalesVideoId && this.inventorySalesVideoId > 0 && this.inventoryItem && this.inventoryItem.salesVideos) {
        const rowFound = this.inventoryItem.salesVideos.find(x => x.id === this.inventorySalesVideoId)
        if (rowFound) {
          return rowFound
        }
      }
      return null
    },
    hasSalesVideo: function () {
      if (this.referencedSalesVideo && this.referencedSalesVideo.fileLocation) {
        return true
      }
      return false
    },
    videoUrl: function () {
      if (this.referencedSalesVideo && this.referencedSalesVideo.fileLocation) {
        const videoUrl = process.env.VUE_APP_LIVE_API + 'video/stream?url=' + encodeURI(this.referencedSalesVideo.fileLocation)
        return videoUrl
      }
      return ''
    },
    hasInventoryPhotoFiles: function () {
      if (this.inventoryPhotoFiles.length > 0) {
        return true
      }
      return false
    },
    includedAttachments: function () {
      const includedIdValues = this.attachmentMediaIds.split(',').map(Number)
      var result = []
      if (this.referencedSalesVideo && this.referencedSalesVideo.attachments && includedIdValues.length > 0) {
        this.referencedSalesVideo.attachments.forEach((attachment) => {
          const attachmentId = attachment.id
          if (includedIdValues.includes(attachmentId)) {
            const includedAttachment = {
              id: attachment.id,
              fileLocation: attachment.fileLocation,
              description: attachment.description
            }
            result.push(includedAttachment)
          }
        })
        return result
      }
      return []
    },
    hasIncludedAttachments: function () {
      if (this.includedAttachments && this.includedAttachments.length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    initInputValues () {
      if (this.inventoryItem) {
        this.inventoryItem.attachments.forEach((x) => {
          x.loaded = true
          x.imageData = x.fileLocation
          x.fileType = this.getFileType(x.fileLocation)
          if (x.classType === 'Primary') {
            this.inventoryPhotoFiles.push(x)
          }
        })
      }
    },
    makeOverview: function (inventory) {
      if (!inventory) {
        return ''
      }
      var result = ''
      result = inventory.stockNo
      result += '<br /> ' + inventory.name
      if (inventory.usage) {
        result += '<br /> ' + new Intl.NumberFormat().format(inventory.usage) + ' miles'
      } else {
        result += '<br /> Milage not captured.'
      }
      var exteriorColor = inventory.attributes.find((x) => x.name === 'ExteriorColor')
      var interiorColor = inventory.attributes.find((x) => x.name === 'InteriorColor')
      if (exteriorColor && exteriorColor.value) {
        result += '<br /> Ext. Color (' + exteriorColor.value + ')'
      }
      if (interiorColor && interiorColor.value) {
        result += '<br /> Int. Color (' + interiorColor.value + ')'
      }

      return result
    },
    getFileType: function (fileName) {
      if (!fileName) {
        return ''
      }
      var extension = fileName.split('.').pop()
      extension = extension.toLowerCase()
      if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'gif') {
        return 'image/' + extension
      }
      if (extension === 'pdf' || extension === 'doc' || extension === 'txt') {
        return 'application/' + extension
      }
      return 'unknown'
    },
    onDownloadSalesVideo: function (row) {
      window.location = row.fileLocation
    },
    onViewSalesVideoImages: function () {
      const viewer = this.$refs.salesVideosImageViewer
      if (!viewer || !viewer.$viewer || typeof viewer.$viewer.show !== 'function') {
        // Prevent runtime errors when the directive hasn’t instantiated the viewer
        return
      }
      viewer.$viewer.show()
    },
    onViewInventoryImages: function () {
      const viewer = this.$refs.inventoryImageViewer
      if (!viewer || !viewer.$viewer || typeof viewer.$viewer.show !== 'function') {
        // Prevent runtime errors when the directive hasn’t instantiated the viewer
        return
      }
      viewer.$viewer.show()
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
  },
  watch: {
    inventoryItem: function (newValue, oldValue) {
      if (newValue) {
        this.initInputValues()
      }
    }
  }
}

</script>

<style scoped>
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px;
}

.image-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 1rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  margin-bottom: 42px;
}

.footer-content p {
  margin: 0;
}

</style>
